module.exports = __webpack_public_path__ + "static/media/people-cost-modular.fd6688c4.jpg";